import {
  Component,
  ViewEncapsulation,
  OnInit,
  OnDestroy,
  AfterViewInit,
  ElementRef,
  ChangeDetectorRef,
  ViewChild,
} from '@angular/core';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { RouterModule, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { RegisterApiService, PowerStation } from '../../core/services/register-api.service';
import {
  GoogleMapsLocationService,
  InteractiveLocationMapHandle,
  PreviewLocationMapHandle,
} from '../../core/services/google-maps-location.service';
import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  customClass: {
    popup: 'premium-toast-popup',
    title: 'premium-toast-title',
  },
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  },
});

@Component({
  selector: 'app-non-mnfg-register',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  templateUrl: './non-mnfg-register.component.html',
  styleUrls: ['./non-mnfg-register.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NonMnfgRegisterComponent implements OnInit, OnDestroy, AfterViewInit {
  registerForm: FormGroup;
  activeStep = 0;
  totalSteps = 5;
  showFormPreview = false;
  Object = Object;

  // Power station dropdown data
  powerStations: PowerStation[] = [];
  stationsLoading = false;
  stationsError = false;

  states: any[] = [];
  statesLoading = false;
  statesError = false;

  districts: any[] = [];
  districtsLoading = false;
  districtsError = false;

  taluks: any[] = [];
  taluksLoading = false;
  taluksError = false;

  villages: any[] = [];
  villagesLoading = false;
  villagesError = false;

  // Company Address Dropdown data and states
  companyDistricts: any[] = [];
  companyDistrictsLoading = false;
  companyDistrictsError = false;

  mobileCheckStatus: 'checking' | 'exists' | 'valid' | null = null;
  mobileCheckErrorMsg: string = '';

  emailCheckStatus: 'idle' | 'checking' | 'valid' | 'exists' = 'idle';
  emailCheckErrorMsg: string = '';

  isSubmitted: boolean = false;

  mobileOtpForm: FormGroup;
  mobileOtpSent = false;
  mobileOtpVerified = false;
  mobileOtpGenerating = false;
  mobileOtpVerifying = false;
  mobileOtpResendLoading = false;
  mobileOtpError = '';
  mobileOtpSuccess = '';
  mobileOtpResendCountdown = 0;
  otpVerifiedMobile = '';
  readonly mobileOtpFields = ['otp1', 'otp2', 'otp3', 'otp4'] as const;
  private mobileOtpResendTimerId: ReturnType<typeof setInterval> | null = null;
  private readonly MOBILE_OTP_RESEND_SECONDS = 60;

  emailOtpForm: FormGroup;
  emailOtpSent = false;
  emailOtpVerified = false;
  emailOtpGenerating = false;
  emailOtpVerifying = false;
  emailOtpResendLoading = false;
  emailOtpError = '';
  emailOtpSuccess = '';
  emailOtpResendCountdown = 0;
  otpVerifiedEmail = '';
  readonly emailOtpFields = ['emailOtp1', 'emailOtp2', 'emailOtp3', 'emailOtp4'] as const;
  private emailOtpResendTimerId: ReturnType<typeof setInterval> | null = null;
  private readonly EMAIL_OTP_RESEND_SECONDS = 60;

  companyTaluks: any[] = [];
  companyTaluksLoading = false;
  companyTaluksError = false;

  companyVillages: any[] = [];
  companyVillagesLoading = false;
  companyVillagesError = false;

  @ViewChild('plantMapContainer') plantMapContainer?: ElementRef<HTMLDivElement>;
  @ViewChild('companyMapContainer') companyMapContainer?: ElementRef<HTMLDivElement>;
  @ViewChild('plantLocationSearch') plantLocationSearch?: ElementRef<HTMLInputElement>;
  @ViewChild('companyLocationSearch') companyLocationSearch?: ElementRef<HTMLInputElement>;
  @ViewChild('previewPlantMapContainer') previewPlantMapContainer?: ElementRef<HTMLDivElement>;
  @ViewChild('previewCompanyMapContainer') previewCompanyMapContainer?: ElementRef<HTMLDivElement>;

  locationMapError = '';
  previewMapError = '';
  private readonly defaultMapCenter = { lat: 11.1271, lng: 78.6569 };
  private readonly defaultMapZoom = 7;
  private readonly selectedMapZoom = 16;
  private readonly addressStepIndex = 2;
  private plantLocationMap: InteractiveLocationMapHandle | null = null;
  private companyLocationMap: InteractiveLocationMapHandle | null = null;
  private previewPlantMap: PreviewLocationMapHandle | null = null;
  private previewCompanyMap: PreviewLocationMapHandle | null = null;
  private locationMapInitTimer: ReturnType<typeof setTimeout> | null = null;
  private previewMapInitTimer: ReturnType<typeof setTimeout> | null = null;

  // Track file upload states
  uploadedFiles: { [key: string]: File | null } = {
    idProof: null,
    pollutionClearance: null,
    inspectionStatus: null,
    gpsMapCameraPhoto: null,
  };

  uploadedFileIds: { [key: string]: string | null } = {
    idProof: null,
    pollutionClearance: null,
    inspectionStatus: null,
    gpsMapCameraPhoto: null,
  };

  docLabels: { [key: string]: string } = {
    idProof: 'Identity Proof',
    pollutionClearance: 'Prior Permission of the State Pollution Control Board',
    inspectionStatus: 'Inspection Status',
    gpsMapCameraPhoto: 'GPS Map Camera Photo',
  };

  // Map component file keys to hardcoded API document type IDs
  documentTypeIds: { [key: string]: number } = {
    idProof: 16,
    pollutionClearance: 17,
    inspectionStatus: 18,
    gpsMapCameraPhoto: 11,
  };

  activeUploadDocKey: string | null = null;
  selectedFileForUpload: File | null = null;
  isUploading = false;
  uploadProgress = 0;

  showCategoryDropdown = false;
  showAshCategoryDropdown = false;
  showProductDropdown = false;
  selectedProductIds: number[] = [];
  flyAshProducts: any[] = [];
  productsLoading = false;
  productsError = false;
  showStepper = true; // controls sidebar stepper visibility
  stepperReady = false; // false on initial load — prevents transition flash

  toggleStepper() {
    this.showStepper = !this.showStepper;
  }

  toggleCategoryDropdown() {
    this.showCategoryDropdown = !this.showCategoryDropdown;
    if (this.showCategoryDropdown) {
      this.showAshCategoryDropdown = false;
    }
  }

  toggleProductDropdown() {
    this.showProductDropdown = !this.showProductDropdown;
    if (this.showProductDropdown) {
      this.showAshCategoryDropdown = false;
      this.showCategoryDropdown = false;
    }
  }

  toggleAshCategoryDropdown() {
    this.showAshCategoryDropdown = !this.showAshCategoryDropdown;
    if (this.showAshCategoryDropdown) {
      this.showCategoryDropdown = false;
      this.showProductDropdown = false;
    }
  }

  // Categories list
  nonMnfgCategoriesList: any[] = [];
  ashCategoriesList: any[] = [];
  categoriesLoading = false;
  ashCategoriesLoading = false;

  getSelectedCategories(): any[] {
    const formArray = this.registerForm?.get('nonManufactureCategoryDetails') as FormArray;
    if (!formArray) return [];
    return formArray.value
      .map((val: any) => {
        const catObj = this.nonMnfgCategoriesList.find((c) => c.id === val.categoryId);
        return catObj ? catObj : null;
      })
      .filter((c: any) => c != null);
  }

  removeCategory(id: any) {
    const formArray = this.registerForm.get('nonManufactureCategoryDetails') as FormArray;
    if (formArray) {
      const idx = formArray.controls.findIndex((ctrl) => ctrl.value.categoryId === id);
      if (idx > -1) {
        formArray.removeAt(idx);
        this.cdr.detectChanges();
      }
    }
  }

  getSelectedAshCategories(): any[] {
    const formArray = this.registerForm?.get('ashCategoryDetails') as FormArray;
    if (!formArray) return [];
    const capacity = this.registerForm.get('capacity')?.value || 0;
    return formArray.value
      .map((val: any) => {
        const catObj = this.ashCategoriesList.find((c) => String(c.id) === String(val.categoryId));
        return catObj
          ? {
              ...catObj,
              minLoad: val.minLoad,
              maxLoad: val.maxLoad,
              minQty: val.minLoad ? val.minLoad * capacity : null,
              maxQty: val.maxLoad ? val.maxLoad * capacity : null,
            }
          : null;
      })
      .filter((c: any) => c != null);
  }

  removeAshCategory(id: any) {
    const formArray = this.registerForm.get('ashCategoryDetails') as FormArray;
    if (formArray) {
      const idx = formArray.controls.findIndex((ctrl) => ctrl.value.categoryId === id);
      if (idx > -1) {
        formArray.removeAt(idx);
        this.cdr.detectChanges();
      }
    }
  }

  isCategorySelected(id: any): boolean {
    return this.getSelectedCategories().some((c: any) => c.id === id);
  }

  isAshCategorySelected(id: any): boolean {
    return this.getSelectedAshCategories().some((c: any) => c.id === id);
  }

  toggleCategorySelection(id: any, isChecked: boolean) {
    const formArray = this.registerForm.get('nonManufactureCategoryDetails') as FormArray;
    if (isChecked) {
      formArray.push(this.fb.group({ categoryId: id }));
    } else {
      this.removeCategory(id);
    }
  }

  toggleAshCategorySelection(id: any, isChecked: boolean) {
    const formArray = this.registerForm.get('ashCategoryDetails') as FormArray;
    if (isChecked) {
      formArray.push(
        this.fb.group({
          categoryId: id,
          minLoad: ['', [Validators.required, Validators.min(1)]],
          maxLoad: ['', [Validators.required, Validators.min(1)]],
        }),
      );
    } else {
      this.removeAshCategory(id);
    }
  }

  get ashCategoryControls(): any[] {
    return (this.registerForm.get('ashCategoryDetails') as FormArray).controls;
  }

  getCategoryFormGroup(id: any): FormGroup | null {
    const formArray = this.registerForm.get('ashCategoryDetails') as FormArray;
    const group = formArray.controls.find((ctrl) => String(ctrl.value.categoryId) === String(id));
    return (group as FormGroup) || null;
  }

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private el: ElementRef,
    private registerApiService: RegisterApiService,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private googleMapsLocationService: GoogleMapsLocationService,
  ) {
    this.registerForm = this.fb.group({
      station: ['', Validators.required],
      mobileNumber: ['', [Validators.required, Validators.pattern('^[6-9][0-9]{9}$')]],

      firmName: ['', Validators.required],
      emailAddress: ['', [Validators.required, Validators.email, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/)]],
      idProof: ['', Validators.required],

      nonMnfgCategory: ['', Validators.required],
      capacity: ['', Validators.required],
      ashCategoryDetails: this.fb.array([], Validators.required),

      // Address Fields
      state: ['Tamil Nadu', Validators.required],
      district: ['', Validators.required],
      taluk: ['', Validators.required],
      village: ['', Validators.required],
      pincode: ['', [Validators.required, Validators.pattern('^[0-9]{6}$')]],
      doorNo: ['', Validators.required],
      surveyFieldNo: ['', Validators.required],
      streetLocation: ['', Validators.required],
      latitude: [''],
      longitude: [''],
      sameAsPlantAddress: [false],
      companyState: ['Tamil Nadu'],
      companyDistrict: [''],
      companyTaluk: [''],
      companyVillage: [''],
      companyPincode: [''],
      companyDoorNo: [''],
      companySurveyFieldNo: [''],
      companyStreetLocation: [''],
      companyLatitude: [''],
      companyLongitude: [''],

      declarationCheck: [false, Validators.requiredTrue],
      declarationCheck2: [false, Validators.requiredTrue],
    });

    this.mobileOtpForm = this.createMobileOtpForm();
    this.emailOtpForm = this.createEmailOtpForm();
  }

  private createMobileOtpForm(): FormGroup {
    const controls: Record<string, unknown[]> = {};
    for (const field of this.mobileOtpFields) {
      controls[field] = ['', [Validators.required, Validators.pattern(/^\d$/)]];
    }
    return this.fb.group(controls);
  }

  private createEmailOtpForm(): FormGroup {
    const controls: Record<string, unknown[]> = {};
    for (const field of this.emailOtpFields) {
      controls[field] = ['', [Validators.required, Validators.pattern(/^\d$/)]];
    }
    return this.fb.group(controls);
  }

  private documentClickListener: any;

  ngOnInit() {
    document.body.classList.add('register-page');

    // Close dropdowns when clicking outside
    this.documentClickListener = () => {
      this.cdr.detectChanges();
    };
    window.addEventListener('click', this.documentClickListener);

    // Load initial dropdowns
    this.loadPowerStations();
    this.loadStates();
    this.loadNonManufactureCategories();
    this.loadFlyAshProducts();

    this.registerForm.get('station')?.valueChanges.subscribe((stationId) => {
      if (stationId) {
        this.loadAshCategories();
      }
    });

    // Subscribe to State changes
    this.registerForm.get('state')?.valueChanges.subscribe((stateId) => {
      this.districts = [];
      this.taluks = [];
      this.villages = [];
      this.registerForm.get('district')?.setValue('');
      this.registerForm.get('taluk')?.setValue('');
      this.registerForm.get('village')?.setValue('');
      if (stateId) {
        this.loadDistricts(stateId);
      }
    });

    // Subscribe to District changes
    this.registerForm.get('district')?.valueChanges.subscribe((districtId) => {
      this.taluks = [];
      this.villages = [];
      this.registerForm.get('taluk')?.setValue('');
      this.registerForm.get('village')?.setValue('');
      if (districtId) {
        this.loadTaluks(districtId);
      }
    });

    // Subscribe to Taluk changes
    this.registerForm.get('taluk')?.valueChanges.subscribe((talukId) => {
      this.villages = [];
      this.registerForm.get('village')?.setValue('');
      if (talukId) {
        this.loadVillages(talukId);
      }
    });

    // Subscribe to sameAsPlantAddress checkbox
    this.registerForm.get('sameAsPlantAddress')?.valueChanges.subscribe((isSame) => {
      const companyStateControl = this.registerForm.get('companyState');
      const companyDistrictControl = this.registerForm.get('companyDistrict');
      const companyTalukControl = this.registerForm.get('companyTaluk');
      const companyVillageControl = this.registerForm.get('companyVillage');
      const companyPincodeControl = this.registerForm.get('companyPincode');
      const companyDoorNoControl = this.registerForm.get('companyDoorNo');
      const companySurveyFieldNoControl = this.registerForm.get('companySurveyFieldNo');
      const companyStreetLocationControl = this.registerForm.get('companyStreetLocation');
      const companyLatitudeControl = this.registerForm.get('companyLatitude');
      const companyLongitudeControl = this.registerForm.get('companyLongitude');

      if (isSame) {
        companyStateControl?.setValue(this.registerForm.get('state')?.value);
        companyDistrictControl?.setValue(this.registerForm.get('district')?.value);
        companyTalukControl?.setValue(this.registerForm.get('taluk')?.value);
        companyVillageControl?.setValue(this.registerForm.get('village')?.value);
        companyPincodeControl?.setValue(this.registerForm.get('pincode')?.value);
        companyDoorNoControl?.setValue(this.registerForm.get('doorNo')?.value);
        companySurveyFieldNoControl?.setValue(this.registerForm.get('surveyFieldNo')?.value);
        companyStreetLocationControl?.setValue(this.registerForm.get('streetLocation')?.value);
        companyLatitudeControl?.setValue(this.registerForm.get('latitude')?.value);
        companyLongitudeControl?.setValue(this.registerForm.get('longitude')?.value);

        companyDistrictControl?.clearValidators();
        companyTalukControl?.clearValidators();
        companyVillageControl?.clearValidators();
        companyPincodeControl?.clearValidators();
        companyDoorNoControl?.clearValidators();
        companySurveyFieldNoControl?.clearValidators();
        companyStreetLocationControl?.clearValidators();
        companyLatitudeControl?.clearValidators();
        companyLongitudeControl?.clearValidators();
        companyDistrictControl?.updateValueAndValidity();
        companyTalukControl?.updateValueAndValidity();
        companyVillageControl?.updateValueAndValidity();
        companyPincodeControl?.updateValueAndValidity();
        companyDoorNoControl?.updateValueAndValidity();
        companySurveyFieldNoControl?.updateValueAndValidity();
        companyStreetLocationControl?.updateValueAndValidity();
        companyLatitudeControl?.updateValueAndValidity();
        companyLongitudeControl?.updateValueAndValidity();
        this.companyLocationMap?.destroy();
        this.companyLocationMap = null;
      } else {
        this.companyLocationMap?.destroy();
        this.companyLocationMap = null;
        const tn = this.states.find(
          (s: any) => s.name?.toLowerCase().replace(/\s/g, '') === 'tamilnadu',
        );
        companyStateControl?.setValue(tn ? tn.id : '');
        companyDistrictControl?.setValue('');
        companyTalukControl?.setValue('');
        companyVillageControl?.setValue('');
        companyPincodeControl?.setValue('');
        companyDoorNoControl?.setValue('');
        companySurveyFieldNoControl?.setValue('');
        companyStreetLocationControl?.setValue('');
        companyLatitudeControl?.setValue('');
        companyLongitudeControl?.setValue('');

        this.companyDistricts = [];
        this.companyTaluks = [];
        this.companyVillages = [];

        companyDistrictControl?.setValidators(Validators.required);
        companyTalukControl?.setValidators(Validators.required);
        companyVillageControl?.setValidators(Validators.required);
        companyPincodeControl?.setValidators([
          Validators.required,
          Validators.pattern('^[0-9]{6}$'),
        ]);
        companyDoorNoControl?.setValidators(Validators.required);
        companySurveyFieldNoControl?.setValidators(Validators.required);
        companyStreetLocationControl?.setValidators(Validators.required);
        companyLatitudeControl?.clearValidators();
        companyLongitudeControl?.clearValidators();
        companyDistrictControl?.updateValueAndValidity();
        companyTalukControl?.updateValueAndValidity();
        companyVillageControl?.updateValueAndValidity();
        companyPincodeControl?.updateValueAndValidity();
        companyDoorNoControl?.updateValueAndValidity();
        companySurveyFieldNoControl?.updateValueAndValidity();
        companyStreetLocationControl?.updateValueAndValidity();
        companyLatitudeControl?.updateValueAndValidity();
        companyLongitudeControl?.updateValueAndValidity();
        this.refreshMapSections();
      }
    });

    // Subscribe to Company State changes
    this.registerForm.get('companyState')?.valueChanges.subscribe((stateId) => {
      this.companyDistricts = [];
      this.companyTaluks = [];
      this.companyVillages = [];
      this.registerForm.get('companyDistrict')?.setValue('');
      this.registerForm.get('companyTaluk')?.setValue('');
      this.registerForm.get('companyVillage')?.setValue('');
      if (stateId) {
        this.loadCompanyDistricts(stateId);
      }
    });

    // Subscribe to Company District changes
    this.registerForm.get('companyDistrict')?.valueChanges.subscribe((districtId) => {
      this.companyTaluks = [];
      this.companyVillages = [];
      this.registerForm.get('companyTaluk')?.setValue('');
      this.registerForm.get('companyVillage')?.setValue('');
      if (districtId) {
        this.loadCompanyTaluks(districtId);
      }
    });

    // Subscribe to Company Taluk changes
    this.registerForm.get('companyTaluk')?.valueChanges.subscribe((talukId) => {
      this.companyVillages = [];
      this.registerForm.get('companyVillage')?.setValue('');
      if (talukId) {
        this.loadCompanyVillages(talukId);
      }
    });

    this.registerForm.get('mobileNumber')?.valueChanges.subscribe((value) => {
      const mobile = String(value || '');

      if (this.mobileOtpVerified && mobile === this.otpVerifiedMobile) {
        return;
      }

      if (this.mobileOtpVerifying) {
        return;
      }

      if (mobile !== this.otpVerifiedMobile) {
        this.resetMobileOtpState();
      }

      if (mobile.length === 10 && /^[6-9][0-9]{9}$/.test(mobile)) {
        this.mobileCheckStatus = 'checking';
        this.cdr.detectChanges();
        this.registerApiService.checkMobileExists(value).subscribe({
          next: (res) => {
            if (res && res.status === false) {
              this.mobileCheckStatus = 'exists';
              this.mobileCheckErrorMsg = res.message || 'This mobile number is already registered!';
              this.registerForm.get('mobileNumber')?.setErrors({ alreadyRegistered: true });
            } else {
              this.mobileCheckStatus = 'valid';
              this.mobileCheckErrorMsg = '';
              const currentErrors = this.registerForm.get('mobileNumber')?.errors;
              if (currentErrors) {
                delete currentErrors['alreadyRegistered'];
                if (Object.keys(currentErrors).length === 0) {
                  this.registerForm.get('mobileNumber')?.setErrors(null);
                } else {
                  this.registerForm.get('mobileNumber')?.setErrors(currentErrors);
                }
              }
            }
            this.cdr.detectChanges();
          },
          error: (err) => {
            const errMsg = err?.error?.message || 'Error validating mobile number.';
            if (
              (errMsg || '').toLowerCase().includes('already') ||
              (errMsg || '').toLowerCase().includes('pending') ||
              err?.error?.status === false
            ) {
              this.mobileCheckStatus = 'exists';
              this.mobileCheckErrorMsg = errMsg;
              this.registerForm.get('mobileNumber')?.setErrors({ alreadyRegistered: true });
            } else {
              this.mobileCheckStatus = 'valid';
              this.mobileCheckErrorMsg = '';
            }
            this.cdr.detectChanges();
          },
        });
      } else {
        this.mobileCheckStatus = null;
        this.cdr.detectChanges();
      }
    });

    this.registerForm.get('emailAddress')?.valueChanges.subscribe((value) => {
      const email = String(value || '')
        .trim()
        .toLowerCase();

      if (this.emailOtpVerified && email === this.otpVerifiedEmail) {
        return;
      }

      if (this.emailOtpVerifying) {
        return;
      }

      if (email !== this.otpVerifiedEmail) {
        this.resetEmailOtpState();
      }
    });
  }

  // --- API Loaders ---
  private extractData(res: any): any[] {
    if (Array.isArray(res)) return res;
    if (Array.isArray(res?.data)) return res.data;
    if (Array.isArray(res?.items)) return res.items;
    return [];
  }

  loadNonManufactureCategories() {
    this.categoriesLoading = true;
    this.registerApiService
      .getNonManufactureCategoriesDropdown()
      .pipe(
        finalize(() => {
          this.categoriesLoading = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (res) => {
          this.nonMnfgCategoriesList = this.extractData(res);
        },
        error: (err) => {
          console.error('Error loading non-manufacturing categories:', err);
        },
      });
  }

  loadFlyAshProducts() {
    this.productsLoading = true;
    this.registerApiService
      .getFlyAshProducts()
      .pipe(
        finalize(() => {
          this.productsLoading = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (res) => {
          this.flyAshProducts = this.extractData(res);
        },
        error: (err) => {
          this.productsError = true;
          this.flyAshProducts = [];
        },
      });
  }

  isFlyAshProductChecked(id: number): boolean {
    return this.selectedProductIds.includes(id);
  }

  isOthersProductSelected(): boolean {
    return this.getSelectedProducts().some(
      (p) => p.name.toLowerCase() === 'others' || p.name.toLowerCase() === 'other',
    );
  }

  toggleFlyAshProduct(id: number) {
    const index = this.selectedProductIds.indexOf(id);
    if (index === -1) {
      this.selectedProductIds.push(id);
    } else {
      this.selectedProductIds.splice(index, 1);
    }
    this.loadAshCategories();
  }

  getSelectedProducts(): { id: number; name: string }[] {
    return this.flyAshProducts.filter((p) => this.selectedProductIds.includes(p.id));
  }

  removeProduct(id: number) {
    this.selectedProductIds = this.selectedProductIds.filter((pid) => pid !== id);
    this.loadAshCategories();
  }

  getProductName(): string {
    return this.getSelectedProducts()
      .map((p) => p.name)
      .join(', ');
  }

  getMinQuantity(min: number): string {
    return '';
  }

  getMaxQuantity(max: number): string {
    return '';
  }

  calculateDynamicMin(minLoad: any): number {
    const capacity = Number(this.registerForm.get('capacity')?.value) || 0;
    return Number(minLoad || 0) * capacity;
  }

  calculateDynamicMax(maxLoad: any): number {
    const capacity = Number(this.registerForm.get('capacity')?.value) || 0;
    return Number(maxLoad || 0) * capacity;
  }

  loadAshCategories() {
    const stationId = this.registerForm.get('station')?.value;
    if (!stationId) return;

    this.ashCategoriesLoading = true;
    this.registerApiService
      .getAshCategories(stationId, undefined, [])
      .pipe(
        finalize(() => {
          this.ashCategoriesLoading = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (res) => {
          this.ashCategoriesList = this.extractData(res);
        },
        error: (err) => {
          console.error('Error loading ash categories:', err);
          this.ashCategoriesList = [];
        },
      });
  }

  loadPowerStations() {
    this.stationsLoading = true;
    this.stationsError = false;
    this.registerApiService
      .getPowerStations()
      .pipe(
        finalize(() => {
          this.stationsLoading = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (res) => {
          this.powerStations =
            this.extractData(res) || (Array.isArray(res?.stations) ? res.stations : []);
        },
        error: (err) => {
          console.error('Error loading stations:', err);
          this.stationsError = true;
        },
      });
  }

  loadStates() {
    this.statesLoading = true;
    this.statesError = false;
    this.registerApiService
      .getStates()
      .pipe(
        finalize(() => {
          this.statesLoading = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (res) => {
          this.states = this.extractData(res);
          const tn = this.states.find(
            (s: any) => s.name?.toLowerCase().replace(/\s/g, '') === 'tamilnadu',
          );
          if (tn) {
            this.registerForm.patchValue({ state: tn.id, companyState: tn.id });
          }
        },
        error: (err) => {
          console.error('Error loading states:', err);
          this.statesError = true;
        },
      });
  }

  loadDistricts(stateId: string | number) {
    this.districtsLoading = true;
    this.districtsError = false;
    this.registerApiService
      .getDistricts(stateId)
      .pipe(
        finalize(() => {
          this.districtsLoading = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (res) => {
          this.districts = this.extractData(res);
        },
        error: (err) => {
          console.error('Error loading districts:', err);
          this.districtsError = true;
        },
      });
  }

  loadTaluks(districtId: string | number) {
    this.taluksLoading = true;
    this.taluksError = false;
    this.registerApiService
      .getTaluks(districtId)
      .pipe(
        finalize(() => {
          this.taluksLoading = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (res) => {
          this.taluks = this.extractData(res);
        },
        error: (err) => {
          console.error('Error loading taluks:', err);
          this.taluksError = true;
        },
      });
  }

  loadVillages(talukId: string | number) {
    this.villagesLoading = true;
    this.villagesError = false;
    this.registerApiService
      .getVillages(talukId)
      .pipe(
        finalize(() => {
          this.villagesLoading = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (res) => {
          this.villages = this.extractData(res);
        },
        error: (err) => {
          console.error('Error loading villages:', err);
          this.villagesError = true;
        },
      });
  }

  // Company Address Loaders
  loadCompanyDistricts(stateId: string | number) {
    this.companyDistrictsLoading = true;
    this.companyDistrictsError = false;
    this.registerApiService
      .getDistricts(stateId)
      .pipe(
        finalize(() => {
          this.companyDistrictsLoading = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (res) => {
          this.companyDistricts = this.extractData(res);
        },
        error: (err) => {
          console.error('Error loading company districts:', err);
          this.companyDistrictsError = true;
        },
      });
  }

  loadCompanyTaluks(districtId: string | number) {
    this.companyTaluksLoading = true;
    this.companyTaluksError = false;
    this.registerApiService
      .getTaluks(districtId)
      .pipe(
        finalize(() => {
          this.companyTaluksLoading = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (res) => {
          this.companyTaluks = this.extractData(res);
        },
        error: (err) => {
          console.error('Error loading company taluks:', err);
          this.companyTaluksError = true;
        },
      });
  }

  loadCompanyVillages(talukId: string | number) {
    this.companyVillagesLoading = true;
    this.companyVillagesError = false;
    this.registerApiService
      .getVillages(talukId)
      .pipe(
        finalize(() => {
          this.companyVillagesLoading = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (res) => {
          this.companyVillages = this.extractData(res);
        },
        error: (err) => {
          console.error('Error loading company villages:', err);
          this.companyVillagesError = true;
        },
      });
  }

  ngOnDestroy() {
    document.body.classList.remove('register-page');
    if (this.documentClickListener) {
      window.removeEventListener('click', this.documentClickListener);
    }
    this.clearMobileOtpResendTimer();
    if (this.locationMapInitTimer) {
      clearTimeout(this.locationMapInitTimer);
    }
    if (this.previewMapInitTimer) {
      clearTimeout(this.previewMapInitTimer);
    }
    this.destroyInteractiveLocationMaps();
    this.destroyPreviewLocationMaps();
  }

  get isMobileOtpComplete(): boolean {
    return this.mobileOtpFields.every((field) => this.mobileOtpForm.get(field)?.valid);
  }

  get canGenerateMobileOtp(): boolean {
    return (
      this.mobileCheckStatus === 'valid' &&
      !this.mobileOtpVerified &&
      !this.mobileOtpGenerating &&
      !this.mobileOtpSent
    );
  }

  get isEmailOtpComplete(): boolean {
    return this.emailOtpFields.every((field) => this.emailOtpForm.get(field)?.valid);
  }

  get canGenerateEmailOtp(): boolean {
    const emailCtrl = this.registerForm.get('emailAddress');
    return !!(
      emailCtrl?.valid &&
      !!emailCtrl?.value &&
      !this.emailOtpVerified &&
      !this.emailOtpGenerating &&
      !this.emailOtpSent
    );
  }

  onGenerateMobileOtp(): void {
    const mobileNo = this.getMobileNumber();
    if (!mobileNo || this.mobileCheckStatus !== 'valid') {
      return;
    }

    this.mobileOtpError = '';
    this.mobileOtpSuccess = '';
    this.mobileOtpGenerating = true;
    this.refreshView();

    this.registerApiService
      .generateMobileOtp(mobileNo)
      .pipe(finalize(() => this.refreshView()))
      .subscribe({
        next: (res) => {
          this.mobileOtpGenerating = false;
          if (this.isApiSuccess(res)) {
            this.mobileOtpSent = true;
            this.mobileOtpSuccess =
              this.parseApiMessage(res?.message) || 'OTP sent to your mobile number.';
            this.resetMobileOtpForm();
            this.registerForm.get('mobileNumber')?.disable({ emitEvent: false });
            this.startMobileOtpResendCountdown();
          } else {
            this.mobileOtpError =
              this.parseApiMessage(res?.message) || 'Unable to generate OTP. Please try again.';
          }
        },
        error: (err) => {
          this.mobileOtpGenerating = false;
          this.mobileOtpError =
            this.parseApiMessage(err?.error?.message) ||
            'Unable to generate OTP. Please try again later.';
        },
      });
  }

  onResendMobileOtp(): void {
    if (this.mobileOtpResendCountdown > 0 || this.mobileOtpResendLoading || !this.mobileOtpSent) {
      return;
    }

    const mobileNo = this.getMobileNumber();
    if (!mobileNo) {
      return;
    }

    this.mobileOtpError = '';
    this.mobileOtpResendLoading = true;
    this.refreshView();

    this.registerApiService
      .resendMobileOtp(mobileNo)
      .pipe(finalize(() => this.refreshView()))
      .subscribe({
        next: (res) => {
          this.mobileOtpResendLoading = false;
          if (this.isApiSuccess(res)) {
            this.mobileOtpSuccess =
              this.parseApiMessage(res?.message) || 'OTP resent to your mobile number.';
            this.resetMobileOtpForm();
            this.startMobileOtpResendCountdown();
          } else {
            this.mobileOtpError =
              this.parseApiMessage(res?.message) || 'Unable to resend OTP. Please try again.';
          }
        },
        error: (err) => {
          this.mobileOtpResendLoading = false;
          this.mobileOtpError =
            this.parseApiMessage(err?.error?.message) ||
            'Unable to resend OTP. Please try again later.';
        },
      });
  }

  onVerifyMobileOtp(): void {
    if (this.mobileOtpVerifying) {
      return;
    }

    this.mobileOtpForm.markAllAsTouched();
    this.mobileOtpError = '';

    if (!this.isMobileOtpComplete) {
      this.mobileOtpError = 'OTP is required. Please enter the complete 4-digit code.';
      this.refreshView();
      return;
    }

    const mobileNo = this.getMobileNumber();
    const otp = this.getMobileOtpValue();
    if (!mobileNo) {
      this.mobileOtpError =
        'Mobile number is missing. Please change and re-enter your mobile number.';
      this.refreshView();
      return;
    }

    this.mobileOtpVerifying = true;
    this.refreshView();

    this.registerApiService
      .verifyMobileOtp(mobileNo, otp)
      .pipe(
        finalize(() => {
          this.mobileOtpVerifying = false;
          this.refreshView();
        }),
      )
      .subscribe({
        next: (res) => {
          this.clearMobileOtpResendTimer();
          if (this.isApiSuccess(res)) {
            this.mobileOtpVerified = true;
            this.otpVerifiedMobile = mobileNo;
            this.mobileOtpSuccess =
              this.parseApiMessage(res?.message) || 'Mobile number verified successfully.';
            this.mobileOtpError = '';
          } else {
            this.mobileOtpError =
              this.parseApiMessage(res?.message) || 'Invalid OTP. Please try again.';
            this.resetMobileOtpForm();
          }
        },
        error: (err) => {
          this.mobileOtpError =
            this.parseApiMessage(err?.error?.message) || 'Invalid OTP. Please check and try again.';
          this.resetMobileOtpForm();
        },
      });
  }

  changeMobileNumber(): void {
    this.resetMobileOtpState();
    this.mobileCheckStatus = null;
    this.mobileCheckErrorMsg = '';
    this.cdr.detectChanges();
  }

  onMobileOtpInput(event: Event, currentField: string, nextField: string): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/\D/g, '').slice(-1);
    input.value = value;
    this.mobileOtpForm.get(currentField)?.setValue(value);

    if (value && nextField) {
      const nextInput = document.getElementById(nextField) as HTMLInputElement | null;
      nextInput?.focus();
    }

    setTimeout(() => {
      if (this.isMobileOtpComplete) {
        this.onVerifyMobileOtp();
      }
    });
  }

  onMobileOtpKeydown(event: KeyboardEvent, currentField: string, prevField: string): void {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Backspace' && !input.value && prevField) {
      const prevInput = document.getElementById(prevField) as HTMLInputElement | null;
      prevInput?.focus();
    }
  }

  onMobileOtpPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pasted = event.clipboardData?.getData('text') || '';
    const digits = pasted.replace(/\D/g, '').slice(0, this.mobileOtpFields.length);

    this.mobileOtpFields.forEach((field, index) => {
      this.mobileOtpForm.get(field)?.setValue(digits[index] || '');
    });

    const focusIndex = Math.min(digits.length, this.mobileOtpFields.length - 1);
    const focusInput = document.getElementById(
      this.mobileOtpFields[focusIndex],
    ) as HTMLInputElement | null;
    focusInput?.focus();

    setTimeout(() => {
      if (this.isMobileOtpComplete) {
        this.onVerifyMobileOtp();
      }
    });
  }

  private getMobileNumber(): string {
    return String(this.registerForm.getRawValue().mobileNumber || '').trim();
  }

  private getMobileOtpValue(): string {
    return this.mobileOtpFields.map((field) => this.mobileOtpForm.get(field)?.value || '').join('');
  }

  private refreshView(): void {
    queueMicrotask(() => this.cdr.detectChanges());
  }

  // --- Email OTP Methods ---

  onGenerateEmailOtp(): void {
    const email = String(this.registerForm.getRawValue().emailAddress || '').trim();
    if (!email || this.registerForm.get('emailAddress')?.invalid) {
      return;
    }

    this.emailOtpError = '';
    this.emailOtpSuccess = '';
    this.emailOtpGenerating = true;
    this.refreshView();

    this.registerApiService
      .generateEmailOtp(email)
      .pipe(finalize(() => this.refreshView()))
      .subscribe({
        next: (res) => {
          this.emailOtpGenerating = false;
          if (this.isApiSuccess(res)) {
            this.emailOtpSent = true;
            this.emailOtpSuccess =
              this.parseApiMessage(res?.message) || 'OTP sent to your email address.';
            this.resetEmailOtpForm();
            this.registerForm.get('emailAddress')?.disable({ emitEvent: false });
            this.startEmailOtpResendCountdown();
          } else {
            this.emailOtpError =
              this.parseApiMessage(res?.message) || 'Unable to generate OTP. Please try again.';
          }
        },
        error: (err) => {
          this.emailOtpGenerating = false;
          this.emailOtpError =
            this.parseApiMessage(err?.error?.message) ||
            'Unable to generate OTP. Please try again later.';
        },
      });
  }

  onResendEmailOtp(): void {
    if (this.emailOtpResendCountdown > 0 || this.emailOtpResendLoading || !this.emailOtpSent) {
      return;
    }

    const email = String(this.registerForm.getRawValue().emailAddress || '').trim();
    if (!email) return;

    this.emailOtpError = '';
    this.emailOtpResendLoading = true;
    this.refreshView();

    this.registerApiService
      .resendEmailOtp(email)
      .pipe(finalize(() => this.refreshView()))
      .subscribe({
        next: (res) => {
          this.emailOtpResendLoading = false;
          if (this.isApiSuccess(res)) {
            this.emailOtpSuccess =
              this.parseApiMessage(res?.message) || 'OTP resent to your email address.';
            this.resetEmailOtpForm();
            this.startEmailOtpResendCountdown();
          } else {
            this.emailOtpError =
              this.parseApiMessage(res?.message) || 'Unable to resend OTP. Please try again.';
          }
        },
        error: (err) => {
          this.emailOtpResendLoading = false;
          this.emailOtpError =
            this.parseApiMessage(err?.error?.message) ||
            'Unable to resend OTP. Please try again later.';
        },
      });
  }

  onVerifyEmailOtp(): void {
    if (this.emailOtpVerifying) return;

    this.emailOtpForm.markAllAsTouched();
    this.emailOtpError = '';

    if (!this.isEmailOtpComplete) {
      this.emailOtpError = 'OTP is required. Please enter the complete 4-digit code.';
      this.refreshView();
      return;
    }

    const email = String(this.registerForm.getRawValue().emailAddress || '').trim();
    const otp = this.getEmailOtpValue();
    if (!email) {
      this.emailOtpError = 'Email address is missing.';
      this.refreshView();
      return;
    }

    this.emailOtpVerifying = true;
    this.refreshView();

    this.registerApiService
      .verifyEmailOtp(email, otp)
      .pipe(
        finalize(() => {
          this.emailOtpVerifying = false;
          this.refreshView();
        }),
      )
      .subscribe({
        next: (res) => {
          this.clearEmailOtpResendTimer();
          if (this.isApiSuccess(res)) {
            this.emailOtpVerified = true;
            this.otpVerifiedEmail = email;
            this.emailOtpSuccess =
              this.parseApiMessage(res?.message) || 'Email verified successfully.';
            this.emailOtpError = '';
          } else {
            this.emailOtpError =
              this.parseApiMessage(res?.message) || 'Invalid OTP. Please try again.';
            this.resetEmailOtpForm();
          }
        },
        error: (err) => {
          this.emailOtpError =
            this.parseApiMessage(err?.error?.message) || 'Invalid OTP. Please check and try again.';
          this.resetEmailOtpForm();
        },
      });
  }

  changeEmailAddress(): void {
    this.resetEmailOtpState();
    this.cdr.detectChanges();
  }

  onEmailOtpInput(event: Event, currentField: string, nextField: string): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/\D/g, '').slice(-1);
    input.value = value;
    this.emailOtpForm.get(currentField)?.setValue(value);

    if (value && nextField) {
      const nextInput = document.getElementById(nextField) as HTMLInputElement | null;
      nextInput?.focus();
    }

    setTimeout(() => {
      if (this.isEmailOtpComplete) {
        this.onVerifyEmailOtp();
      }
    });
  }

  onEmailOtpKeydown(event: KeyboardEvent, currentField: string, prevField: string): void {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Backspace' && !input.value && prevField) {
      const prevInput = document.getElementById(prevField) as HTMLInputElement | null;
      prevInput?.focus();
    }
  }

  onEmailOtpPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pasted = event.clipboardData?.getData('text') || '';
    const digits = pasted.replace(/\D/g, '').slice(0, this.emailOtpFields.length);

    this.emailOtpFields.forEach((field, index) => {
      this.emailOtpForm.get(field)?.setValue(digits[index] || '');
    });

    const focusIndex = Math.min(digits.length, this.emailOtpFields.length - 1);
    const focusInput = document.getElementById(
      this.emailOtpFields[focusIndex],
    ) as HTMLInputElement | null;
    focusInput?.focus();

    setTimeout(() => {
      if (this.isEmailOtpComplete) {
        this.onVerifyEmailOtp();
      }
    });
  }

  private getEmailOtpValue(): string {
    return this.emailOtpFields.map((field) => this.emailOtpForm.get(field)?.value || '').join('');
  }

  private resetEmailOtpForm(): void {
    this.emailOtpForm.reset();
    for (const field of this.emailOtpFields) {
      this.emailOtpForm.get(field)?.setValue('');
    }
  }

  private resetEmailOtpState(): void {
    this.emailOtpSent = false;
    this.emailOtpVerified = false;
    this.emailOtpGenerating = false;
    this.emailOtpVerifying = false;
    this.emailOtpResendLoading = false;
    this.emailOtpError = '';
    this.emailOtpSuccess = '';
    this.otpVerifiedEmail = '';
    this.clearEmailOtpResendTimer();
    this.resetEmailOtpForm();
    this.registerForm.get('emailAddress')?.enable({ emitEvent: false });
  }

  private startEmailOtpResendCountdown(): void {
    this.clearEmailOtpResendTimer();
    this.emailOtpResendCountdown = this.EMAIL_OTP_RESEND_SECONDS;
    this.emailOtpResendTimerId = setInterval(() => {
      if (this.emailOtpVerifying) {
        return;
      }
      this.emailOtpResendCountdown -= 1;
      if (this.emailOtpResendCountdown <= 0) {
        this.clearEmailOtpResendTimer();
      }
      this.refreshView();
    }, 1000);
  }

  private clearEmailOtpResendTimer(): void {
    if (this.emailOtpResendTimerId) {
      clearInterval(this.emailOtpResendTimerId);
      this.emailOtpResendTimerId = null;
    }
    this.emailOtpResendCountdown = 0;
  }

  private resetMobileOtpForm(): void {
    this.mobileOtpForm.reset();
    for (const field of this.mobileOtpFields) {
      this.mobileOtpForm.get(field)?.setValue('');
    }
  }

  private resetMobileOtpState(): void {
    this.mobileOtpSent = false;
    this.mobileOtpVerified = false;
    this.mobileOtpGenerating = false;
    this.mobileOtpVerifying = false;
    this.mobileOtpResendLoading = false;
    this.mobileOtpError = '';
    this.mobileOtpSuccess = '';
    this.otpVerifiedMobile = '';
    this.clearMobileOtpResendTimer();
    this.resetMobileOtpForm();
    this.registerForm.get('mobileNumber')?.enable({ emitEvent: false });
  }

  private startMobileOtpResendCountdown(): void {
    this.clearMobileOtpResendTimer();
    this.mobileOtpResendCountdown = this.MOBILE_OTP_RESEND_SECONDS;
    this.mobileOtpResendTimerId = setInterval(() => {
      if (this.mobileOtpVerifying) {
        return;
      }
      this.mobileOtpResendCountdown -= 1;
      if (this.mobileOtpResendCountdown <= 0) {
        this.clearMobileOtpResendTimer();
      }
      this.refreshView();
    }, 1000);
  }

  private clearMobileOtpResendTimer(): void {
    if (this.mobileOtpResendTimerId) {
      clearInterval(this.mobileOtpResendTimerId);
      this.mobileOtpResendTimerId = null;
    }
    this.mobileOtpResendCountdown = 0;
  }

  private isApiSuccess(res: any): boolean {
    return res?.status === true || res?.status === 'true' || res?.status === 1;
  }

  private parseApiMessage(message: unknown): string {
    if (Array.isArray(message)) {
      return message
        .map((item) => (typeof item === 'string' ? item : String(item)))
        .filter(Boolean)
        .join(' ');
    }
    if (typeof message === 'string') {
      return message;
    }
    return '';
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.stepperReady = true;
      this.cdr.detectChanges();
      this.refreshMapSections();
    }, 0);
  }

  getProgressPercent(): number {
    return Math.round(((this.activeStep + 1) / this.totalSteps) * 100);
  }

  isStepCompleted(step: number): boolean {
    return step < this.activeStep;
  }

  getStepControlNames(stepNum: number): string[] {
    switch (stepNum) {
      case 0:
        return ['station', 'mobileNumber'];
      case 1:
        return ['firmName', 'emailAddress', 'idProof', 'nonMnfgCategory'];
      case 3:
        return ['ashCategoryDetails'];
      case 2:
        const addressFields = [
          'doorNo',
          'surveyFieldNo',
          'streetLocation',
          'state',
          'district',
          'taluk',
          'village',
          'pincode',
        ];
        if (!this.registerForm.get('sameAsPlantAddress')?.value) {
          addressFields.push(
            'companyDoorNo',
            'companySurveyFieldNo',
            'companyStreetLocation',
            'companyState',
            'companyDistrict',
            'companyTaluk',
            'companyVillage',
            'companyPincode',
          );
        }
        return addressFields;
      case 4:
        return ['declarationCheck', 'declarationCheck2'];
      default:
        return [];
    }
  }

  // isStepValid(stepNum: number): boolean {
  //   return true; // TEMPORARY BYPASS FOR UI TESTING
  // }
  isStepValid(stepNum: number): boolean {
    const controls = this.getStepControlNames(stepNum);

    for (const name of controls) {
      const control = this.registerForm.get(name);

      if (control && control.invalid) {
        return false;
      }
    }

    if (stepNum === 0 && !this.mobileOtpVerified) {
      return false;
    }

    if (stepNum === 2) {
      if (!this.uploadedFiles['gpsMapCameraPhoto']) {
        return false;
      }
    }

    return true;
  }

  markStepControlsAsTouched(stepNum: number) {
    const controls = this.getStepControlNames(stepNum);
    for (const name of controls) {
      const ctrl = this.registerForm.get(name);
      if (ctrl) {
        ctrl.markAsTouched();
        ctrl.updateValueAndValidity({ emitEvent: false });
      }
    }
  }

  setStep(n: number) {
    if (n < this.activeStep) {
      this.activeStep = n;
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.refreshMapSections();
    } else if (n > this.activeStep) {
      let canGoForward = true;
      for (let i = this.activeStep; i < n; i++) {
        if (!this.isStepValid(i)) {
          this.markStepControlsAsTouched(i);
          canGoForward = false;
          break;
        }
      }
      if (canGoForward) {
        this.activeStep = n;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.refreshMapSections();
      } else {
        Toast.fire({
          icon: 'warning',
          title: 'Please fill all required fields in the current step correctly.',
        });
      }
    }
  }

  nextStep() {
    if (this.isStepValid(this.activeStep)) {
      this.saveDraftForCurrentStep(true);
      if (this.activeStep < 4) {
        this.activeStep++;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.refreshMapSections();
      }
    } else {
      this.markStepControlsAsTouched(this.activeStep);
      Toast.fire({
        icon: 'warning',
        title:
          this.activeStep === 0 && !this.mobileOtpVerified
            ? 'Please verify your mobile number with OTP before proceeding.'
            : 'Please fill all required fields in the current step correctly.',
      });
    }
  }

  prevStep() {
    if (this.activeStep > 0) {
      this.activeStep--;
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.refreshMapSections();
    }
  }

  goToNextStep() {
    this.nextStep();
  }

  goToPreviousStep() {
    this.prevStep();
  }

  // Geolocation auto-detect GPS
  detectLocation(type: 'plant' | 'company' = 'plant') {
    if (!navigator.geolocation) {
      Toast.fire({ icon: 'warning', title: 'Geolocation not supported.' });
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const latitude = pos.coords.latitude.toFixed(6);
        const longitude = pos.coords.longitude.toFixed(6);
        if (type === 'plant') {
          this.registerForm.patchValue({ latitude, longitude });
          this.registerForm.get('latitude')?.updateValueAndValidity();
          this.registerForm.get('longitude')?.updateValueAndValidity();
          this.updateMapMarkerFromCoordinates('plant', latitude, longitude);
        } else {
          this.registerForm.patchValue({ companyLatitude: latitude, companyLongitude: longitude });
          this.registerForm.get('companyLatitude')?.updateValueAndValidity();
          this.registerForm.get('companyLongitude')?.updateValueAndValidity();
          this.updateMapMarkerFromCoordinates('company', latitude, longitude);
        }
      },
      () =>
        Toast.fire({
          icon: 'warning',
          title: 'Unable to detect location. Please select on the map.',
        }),
    );
  }

  private scheduleLocationMapsInit(): void {
    if (this.activeStep !== this.addressStepIndex) {
      this.destroyInteractiveLocationMaps();
      return;
    }

    if (this.locationMapInitTimer) {
      clearTimeout(this.locationMapInitTimer);
    }

    this.locationMapInitTimer = setTimeout(() => {
      this.initLocationMaps();
    }, 0);
  }

  private schedulePreviewMapsInit(): void {
    if (!this.showFormPreview) {
      this.destroyPreviewLocationMaps();
      return;
    }

    if (this.previewMapInitTimer) {
      clearTimeout(this.previewMapInitTimer);
    }

    this.previewMapInitTimer = setTimeout(() => {
      this.initPreviewMaps();
    }, 0);
  }

  private refreshMapSections(): void {
    this.scheduleLocationMapsInit();
    this.schedulePreviewMapsInit();
  }

  private destroyInteractiveLocationMaps(): void {
    this.plantLocationMap?.destroy();
    this.companyLocationMap?.destroy();
    this.plantLocationMap = null;
    this.companyLocationMap = null;
  }

  private destroyPreviewLocationMaps(): void {
    this.previewPlantMap?.destroy();
    this.previewCompanyMap?.destroy();
    this.previewPlantMap = null;
    this.previewCompanyMap = null;
  }

  private initLocationMaps(): void {
    this.googleMapsLocationService
      .load(environment.googleMapsApiKey)
      .then(() => {
        this.locationMapError = '';
        this.destroyInteractiveLocationMaps();
        this.initPlantLocationMap();
        if (!this.registerForm.get('sameAsPlantAddress')?.value) {
          this.initCompanyLocationMap();
        }
        this.cdr.detectChanges();
      })
      .catch(() => {
        this.locationMapError = 'Unable to load Google Maps. Please try again later.';
        this.cdr.detectChanges();
      });
  }

  private initPreviewMaps(): void {
    const showCompanyPreview = !this.registerForm.get('sameAsPlantAddress')?.value;

    this.googleMapsLocationService
      .load(environment.googleMapsApiKey)
      .then(() => {
        this.previewMapError = '';
        this.destroyPreviewLocationMaps();

        const plantContainer = this.previewPlantMapContainer?.nativeElement;
        if (plantContainer) {
          this.previewPlantMap = this.googleMapsLocationService.createPreviewMap(plantContainer, {
            defaultCenter: this.defaultMapCenter,
            defaultZoom: this.defaultMapZoom,
            selectedZoom: this.selectedMapZoom,
            coords: this.getCoordinatesFromForm('plant'),
          });
        }

        if (showCompanyPreview) {
          const companyContainer = this.previewCompanyMapContainer?.nativeElement;
          if (companyContainer) {
            this.previewCompanyMap = this.googleMapsLocationService.createPreviewMap(
              companyContainer,
              {
                defaultCenter: this.defaultMapCenter,
                defaultZoom: this.defaultMapZoom,
                selectedZoom: this.selectedMapZoom,
                coords: this.getCoordinatesFromForm('company'),
              },
            );
          }
        }

        this.cdr.detectChanges();
      })
      .catch(() => {
        this.previewMapError = 'Unable to load Google Maps preview. Please try again later.';
        this.cdr.detectChanges();
      });
  }

  private initPlantLocationMap(): void {
    const container = this.plantMapContainer?.nativeElement;
    if (!container) {
      return;
    }

    this.plantLocationMap = this.googleMapsLocationService.createInteractiveMap(container, {
      defaultCenter: this.defaultMapCenter,
      defaultZoom: this.defaultMapZoom,
      selectedZoom: this.selectedMapZoom,
      initialCoords: this.getCoordinatesFromForm('plant'),
      onLocationChange: (lat, lng) => this.patchLocationCoordinates('plant', lat, lng),
    });

    const searchInput = this.plantLocationSearch?.nativeElement;
    if (searchInput) {
      this.plantLocationMap.bindSearchInput(searchInput);
    }
  }

  private initCompanyLocationMap(): void {
    const container = this.companyMapContainer?.nativeElement;
    if (!container) {
      return;
    }

    this.companyLocationMap = this.googleMapsLocationService.createInteractiveMap(container, {
      defaultCenter: this.defaultMapCenter,
      defaultZoom: this.defaultMapZoom,
      selectedZoom: this.selectedMapZoom,
      initialCoords: this.getCoordinatesFromForm('company'),
      onLocationChange: (lat, lng) => this.patchLocationCoordinates('company', lat, lng),
    });

    const searchInput = this.companyLocationSearch?.nativeElement;
    if (searchInput) {
      this.companyLocationMap.bindSearchInput(searchInput);
    }
  }

  private getCoordinatesFromForm(type: 'plant' | 'company'): { lat: number; lng: number } | null {
    const latField = type === 'plant' ? 'latitude' : 'companyLatitude';
    const lngField = type === 'plant' ? 'longitude' : 'companyLongitude';
    return this.googleMapsLocationService.parseCoordinates(
      this.registerForm.get(latField)?.value,
      this.registerForm.get(lngField)?.value,
    );
  }

  private patchLocationCoordinates(type: 'plant' | 'company', lat: number, lng: number): void {
    const latitude = lat.toFixed(6);
    const longitude = lng.toFixed(6);

    if (type === 'plant') {
      this.registerForm.patchValue({ latitude, longitude });
      this.registerForm.get('latitude')?.updateValueAndValidity();
      this.registerForm.get('longitude')?.updateValueAndValidity();
    } else {
      this.registerForm.patchValue({ companyLatitude: latitude, companyLongitude: longitude });
      this.registerForm.get('companyLatitude')?.updateValueAndValidity();
      this.registerForm.get('companyLongitude')?.updateValueAndValidity();
    }
  }

  private updateMapMarkerFromCoordinates(
    type: 'plant' | 'company',
    latitude: string,
    longitude: string,
  ): void {
    const coords = this.googleMapsLocationService.parseCoordinates(latitude, longitude);
    if (!coords) {
      return;
    }

    const handle = type === 'plant' ? this.plantLocationMap : this.companyLocationMap;
    if (!handle) {
      this.scheduleLocationMapsInit();
      return;
    }

    handle.setMarker(coords.lat, coords.lng, true);
  }

  // Handle popup-based uploads
  openUploadPopup(fileKey: string) {
    this.activeUploadDocKey = fileKey;
    this.selectedFileForUpload = null;
    this.isUploading = false;
    this.uploadProgress = 0;
  }

  closeUploadPopup() {
    this.activeUploadDocKey = null;
    this.selectedFileForUpload = null;
    this.isUploading = false;
    this.uploadProgress = 0;
  }

  onModalFileSelected(event: any) {
    const file = event.target.files?.[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        Toast.fire({ icon: 'error', title: 'File size exceeds the 2MB limit.' });
        event.target.value = '';
        return;
      }
      this.selectedFileForUpload = file;
    }
  }

  confirmUpload() {
    if (!this.selectedFileForUpload || !this.activeUploadDocKey) {
      return;
    }

    const docKey = this.activeUploadDocKey;
    const docTypeId = this.documentTypeIds[docKey];

    this.isUploading = true;
    this.uploadProgress = 15;
    this.cdr.detectChanges();

    if (docKey === 'aadhaarDocument') {
      // Mock Aadhaar document upload locally to avoid backend API error
      const interval = setInterval(() => {
        this.uploadProgress += 20;
        if (this.uploadProgress >= 100) {
          clearInterval(interval);
          this.isUploading = false;
          this.uploadedFiles[docKey] = this.selectedFileForUpload;
          this.uploadedFileIds[docKey] =
            `DOC-${docTypeId}-${Math.floor(1000 + Math.random() * 9000)}`;
          this.cdr.detectChanges();

          setTimeout(() => {
            this.closeUploadPopup();
            this.cdr.detectChanges();
            Toast.fire({
              icon: 'success',
              title: `${this.docLabels[docKey]} uploaded successfully!`,
            });
          }, 150);
        }
        this.cdr.detectChanges();
      }, 100);
      return;
    }

    this.registerApiService
      .uploadDocument(docTypeId, this.selectedFileForUpload)
      .pipe(
        finalize(() => {
          this.isUploading = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (res) => {
          this.uploadProgress = 100;
          this.cdr.detectChanges();

          this.uploadedFiles[docKey] = this.selectedFileForUpload;
          const docId =
            res?.data?.id ||
            res?.data?.documentId ||
            res?.id ||
            `DOC-${docTypeId}-${Math.floor(1000 + Math.random() * 9000)}`;
          this.uploadedFileIds[docKey] = docId;

          setTimeout(() => {
            this.closeUploadPopup();
            this.cdr.detectChanges();
            Toast.fire({
              icon: 'success',
              title: `${this.docLabels[docKey]} uploaded successfully!`,
            });
          }, 150);
        },
        error: (err) => {
          console.error('File upload failed:', err);
          Toast.fire({
            icon: 'error',
            title: `Failed to upload ${this.docLabels[docKey]}. Please try again.`,
          });
        },
      });
  }

  onPreview() {
    this.showFormPreview = true;
    this.refreshMapSections();
  }

  closePreview(): void {
    this.showFormPreview = false;
    this.schedulePreviewMapsInit();
  }

  submitFromPreview() {
    Swal.fire({
      title: 'Confirm Submission',
      text: 'Are you sure you want to submit your application?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#00796b',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, submit it!',
      cancelButtonText: 'Review again',
      customClass: {
        popup: 'premium-swal-popup',
        title: 'premium-swal-title',
        confirmButton: 'premium-swal-btn',
        cancelButton: 'premium-swal-btn',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.showFormPreview = false;
        this.handleSubmit();
      }
    });
  }

  getStationName(): string {
    const id = this.registerForm.get('station')?.value;
    const item = this.powerStations.find((x) => x.id == id || x.name === id);
    return item ? item.name : id || 'N/A';
  }

  getStateName(type: 'plant' | 'company' = 'plant'): string {
    const id = this.registerForm.get(type === 'plant' ? 'state' : 'companyState')?.value;
    const item = this.states.find((x) => x.id == id || x.name === id);
    return item ? item.name : id || 'N/A';
  }

  getDistrictName(type: 'plant' | 'company' = 'plant'): string {
    const id = this.registerForm.get(type === 'plant' ? 'district' : 'companyDistrict')?.value;
    const list = type === 'plant' ? this.districts : this.companyDistricts;
    const item = list.find((x: any) => x.id == id || x.name === id || x === id);
    return item ? (item.name ?? item) : id || 'N/A';
  }

  getTalukName(type: 'plant' | 'company' = 'plant'): string {
    const id = this.registerForm.get(type === 'plant' ? 'taluk' : 'companyTaluk')?.value;
    const list = type === 'plant' ? this.taluks : this.companyTaluks;
    const item = list.find((x: any) => x.id == id || x.name === id || x === id);
    return item ? (item.name ?? item) : id || 'N/A';
  }

  getVillageName(type: 'plant' | 'company' = 'plant'): string {
    const id = this.registerForm.get(type === 'plant' ? 'village' : 'companyVillage')?.value;
    const list = type === 'plant' ? this.villages : this.companyVillages;
    const item = list.find((x: any) => x.id == id || x.name === id || x === id);
    return item ? (item.name ?? item) : id || 'N/A';
  }

  handleSubmit() {
    const declarationChecked = this.registerForm.get('declarationCheck')?.value;
    const declarationChecked2 = this.registerForm.get('declarationCheck2')?.value;
    if (!declarationChecked || !declarationChecked2) {
      Toast.fire({
        icon: 'warning',
        title: 'Please read and accept all declarations before submitting.',
      });
      return;
    }

    if (this.registerForm.invalid) {
      this.registerForm.markAllAsTouched();
      Toast.fire({
        icon: 'warning',
        title: 'Please fill all mandatory fields and resolve errors.',
      });
      return;
    }

    if (!this.uploadedFiles['pollutionClearance']) {
      Toast.fire({
        icon: 'warning',
        title: 'Please upload the Prior Pollution Clearance Certificate.',
      });
      return;
    }

    Toast.fire({ icon: 'info', title: 'Submitting your registration application...' });
    const form = this.registerForm.getRawValue();

    const docsArray: any[] = [];
    Object.keys(this.uploadedFileIds).forEach((key) => {
      const fileUploadId = this.uploadedFileIds[key];
      const docTypeId = this.documentTypeIds[key];
      if (fileUploadId && docTypeId) {
        docsArray.push({
          documentTypeId: Number(docTypeId),
          documentUploadId: Number(fileUploadId),
        });
      }
    });

    const isSameAddress = form.sameAsPlantAddress === true;
    const companyStateId = isSameAddress ? Number(form.state) : Number(form.companyState);
    const companyDistrictId = isSameAddress ? Number(form.district) : Number(form.companyDistrict);
    const companyTalukId = isSameAddress ? Number(form.taluk) : Number(form.companyTaluk);
    const companyVillageId = isSameAddress ? Number(form.village) : Number(form.companyVillage);
    const companyDoorNo = isSameAddress ? form.doorNo : form.companyDoorNo;
    const companySfNo = isSameAddress ? form.surveyFieldNo : form.companySurveyFieldNo;
    const companyStreet = isSameAddress ? form.streetLocation : form.companyStreetLocation;
    const companyPincode = isSameAddress ? form.pincode : form.companyPincode;

    const payload = {
      registrationType: '2',
      registrationTypeName: 'Non-Manufacturing',
      powerStationsId: Number(form.station),
      firmName: form.firmName,
      idProof: form.idProof,
      mobileNo: form.mobileNumber,
      email: form.emailAddress,
      nonManufactureCategoryDetails: [{ categoryId: Number(form.nonMnfgCategory) }],
      capacity: Number(form.capacity) || 0,
      ashCategoryDetails: form.ashCategoryDetails.map((item: any) => {
        const cap = Number(form.capacity) || 0;
        const minLd = Number(item.minLoad) || 0;
        const maxLd = Number(item.maxLoad) || 0;

        let minQ = Number((cap * minLd).toFixed(2));
        let maxQ = Number((cap * maxLd).toFixed(2));

        return {
          categoryId: item.categoryId,
          minLoad: minLd,
          maxLoad: maxLd,
          minQuantity: minQ,
          maxQuantity: maxQ,
        };
      }),
      stateId: Number(form.state),
      districtId: Number(form.district),
      talukId: Number(form.taluk),
      villageId: Number(form.village),
      doorNo: form.doorNo,
      sfNo: form.surveyFieldNo,
      street: form.streetLocation,
      pincode: form.pincode,
      isCompanyAddressSameAsPlant: isSameAddress,
      companyStateId: companyStateId,
      companyDistrictId: companyDistrictId,
      companyTalukId: companyTalukId,
      companyVillageId: companyVillageId,
      companyDoorNo: companyDoorNo,
      companySfNo: companySfNo,
      companyStreet: companyStreet,
      companyPincode: companyPincode,
      documents: docsArray,
      isNonManufacturing: true, // flag to differentiate on submit
    };

    this.registerApiService.createNonMnfgRegistration(payload).subscribe({
      next: (res) => {
        const appNo =
          res?.data?.applicationNo ||
          res?.data?.result?.applicationNo ||
          'TNEB-FLY-' + Math.floor(100000 + Math.random() * 900000);
        Swal.fire({
          title: 'Application Submitted',
          html: `Your Application No.: <strong>${appNo}</strong><br><br>An acknowledgement will be sent to your registered email and mobile number.`,
          icon: 'success',
          confirmButtonText: 'Great!',
          confirmButtonColor: '#28a745',
          customClass: {
            popup: 'premium-swal-popup',
            title: 'premium-swal-title',
            confirmButton: 'premium-swal-btn',
          },
        }).then(() => {
          this.router.navigate(['/login']);
        });
      },
      error: (err) => {
        console.error('Registration failed:', err);
        Swal.fire({
          title: 'Submission Failed',
          text:
            err?.error?.message ||
            'Failed to submit registration. Please check the fields and try again.',
          icon: 'error',
          confirmButtonText: 'Try Again',
          confirmButtonColor: '#dc3545',
          customClass: {
            popup: 'premium-swal-popup',
            title: 'premium-swal-title',
            confirmButton: 'premium-swal-btn',
          },
        });
      },
    });
  }

  getNonMnfgCategoryName(): string {
    const id = this.registerForm.get('nonMnfgCategory')?.value;
    const cat = this.nonMnfgCategoriesList.find((c) => String(c.id) === String(id));
    return cat ? cat.name : '';
  }

  getAshCategoryName(id: any): string {
    const cat = this.ashCategoriesList.find((c) => c.id === id);
    return cat ? cat.name : '';
  }

  previewDocumentUrl: SafeResourceUrl | null = null;
  previewDownloadUrl: string | null = null;
  previewDownloadName: string | null = null;

  viewUploadedFile(file: File | null, docKey?: string) {
    if (!file) return;

    if (file.name.endsWith('-draft.pdf') || file.size === 5) {
      if (!docKey) return;
      const uploadId = this.uploadedFileIds[docKey];
      if (!uploadId) return;

      this.registerApiService.downloadDocument(uploadId).subscribe({
        next: (blob: Blob) => {
          let type = 'application/pdf';
          const nameLower = file.name.toLowerCase();
          if (nameLower.endsWith('.png') || nameLower.endsWith('-draft.png')) type = 'image/png';
          else if (
            nameLower.endsWith('.jpg') ||
            nameLower.endsWith('.jpeg') ||
            nameLower.endsWith('-draft.jpg') ||
            nameLower.endsWith('-draft.jpeg')
          )
            type = 'image/jpeg';

          const fileBlob = new Blob([blob], { type });
          const fileURL = URL.createObjectURL(fileBlob);
          this.previewDownloadUrl = fileURL;
          this.previewDownloadName = file.name
            .replace('-draft.pdf', '.pdf')
            .replace('-draft.png', '.png')
            .replace('-draft.jpg', '.jpg')
            .replace('-draft.jpeg', '.jpeg');
          this.previewDocumentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error('Failed to load draft document:', err);
          Toast.fire({ icon: 'error', title: 'Failed to load document preview' });
        },
      });
      return;
    }

    const fileURL = URL.createObjectURL(file);
    this.previewDownloadUrl = fileURL;
    this.previewDownloadName = file.name;
    this.previewDocumentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
  }

  closeDocumentPreview() {
    this.previewDocumentUrl = null;
    this.previewDownloadUrl = null;
    this.previewDownloadName = null;
  }

  downloadPreviewDocument() {
    if (this.previewDownloadUrl && this.previewDownloadName) {
      const a = document.createElement('a');
      a.href = this.previewDownloadUrl;
      a.download = this.previewDownloadName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }

  // ─── Draft Logic ──────────────────────────────────────────────────────────

  isLoadingDraft = false;
  isSavingDraft = false;

  canSaveDraft(): boolean {
    return !!this.otpVerifiedMobile || this.registerForm.get('mobileNumber')?.valid === true;
  }

  get mobileNoForDraft(): string {
    return this.otpVerifiedMobile || this.registerForm.get('mobileNumber')?.value;
  }

  saveDraftForCurrentStep(silent = true): void {
    if (!this.canSaveDraft()) return;
    const mobileNo = this.mobileNoForDraft;
    const val = this.registerForm.value;
    let formData: Record<string, unknown> = {};

    switch (this.activeStep) {
      case 0:
        formData = { powerStationsId: val.station, mobileNo };
        break;
      case 1:
        formData = {
          firmName: val.firmName,
          email: val.emailAddress,
          idProof: val.idProof,
          documents: Object.keys(this.uploadedFileIds)
            .filter((k) => this.uploadedFileIds[k] != null)
            .map((k) => ({
              documentTypeId: this.documentTypeIds[k],
              documentUploadId: Number(this.uploadedFileIds[k]),
            })),
          nonManufactureCategoryDetails: val.nonMnfgCategory
            ? [{ categoryId: Number(val.nonMnfgCategory) }]
            : [],
        };
        break;
      case 2:
        formData = {
          stateId: val.state,
          districtId: val.district,
          talukId: val.taluk,
          villageId: val.village,
          doorNo: val.doorNo,
          sfNo: val.surveyFieldNo,
          street: val.streetLocation,
          pincode: val.pincode,
          isCompanyAddressSameAsPlant: val.sameAsPlantAddress,
          companyStateId: val.companyState,
          companyDistrictId: val.companyDistrict,
          companyTalukId: val.companyTaluk,
          companyVillageId: val.companyVillage,
          companyDoorNo: val.companyDoorNo,
          companySfNo: val.companySurveyFieldNo,
          companyStreet: val.companyStreetLocation,
          companyPincode: val.companyPincode,
        };
        break;
      case 3:
        formData = {
          capacity: val.capacity,
          ashCategoryDetails: (val.ashCategoryDetails || []).map((d: any) => ({
            categoryId: Number(d.categoryId),
            minLoad: Number(d.minLoad),
            maxLoad: Number(d.maxLoad),
          })),
        };
        break;
      case 4:
        formData = {
          documents: Object.keys(this.uploadedFileIds)
            .filter((k) => this.uploadedFileIds[k] != null)
            .map((k) => ({
              documentTypeId: this.documentTypeIds[k],
              documentUploadId: Number(this.uploadedFileIds[k]),
            })),
        };
        break;
    }

    if (Object.keys(formData).length === 0) return;

    const payload = {
      mobileNo,
      registrationType: 4, // non-mnfg registration type
      step: this.activeStep + 1,
      formData,
    };

    if (!silent) this.isSavingDraft = true;

    this.registerApiService
      .saveNonMnfgDraftStep(payload)
      .pipe(
        finalize(() => {
          if (!silent) {
            this.isSavingDraft = false;
            this.cdr.detectChanges();
          }
        }),
      )
      .subscribe({
        next: (res) => {
          if (!silent) Toast.fire({ icon: 'success', title: 'Draft saved successfully!' });
        },
        error: (err) => {
          if (!silent) Toast.fire({ icon: 'error', title: 'Failed to save draft.' });
        },
      });
  }

  onSaveDraft(silent = false): void {
    if (!this.canSaveDraft()) {
      if (!silent)
        Toast.fire({
          icon: 'warning',
          title: 'Enter a valid 10-digit mobile number before saving a draft.',
        });
      return;
    }
    this.saveDraftForCurrentStep(silent);
  }

  onResumeDraft(): void {
    if (this.isLoadingDraft) return;

    Swal.fire({
      title: 'Resume Registration',
      html: `
        <div class="text-start">
          <label class="form-label" style="font-size: 13px; font-weight: 600; color: #475569;">Registered Mobile Number</label>
          <div class="input-group" style="border-radius: 8px; overflow: hidden; box-shadow: 0 2px 4px rgba(0,0,0,0.02);">
            <span class="input-group-text" style="background: #f8fafc; border: 1px solid #e2e8f0; border-right: none; color: #64748b;">+91</span>
            <input type="tel" id="draftMobileNo" class="form-control" placeholder="Enter 10-digit number" maxlength="10"
              style="border: 1px solid #e2e8f0; border-left: none; padding-left: 0; box-shadow: none;"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57">
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Fetch Draft',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#0f766e',
      cancelButtonColor: '#94a3b8',
      customClass: {
        popup: 'premium-swal-popup',
        title: 'premium-swal-title',
        confirmButton: 'premium-swal-btn',
        cancelButton: 'premium-swal-btn-cancel',
      },
      preConfirm: () => {
        const input = document.getElementById('draftMobileNo') as HTMLInputElement;
        const val = input.value.trim();
        if (!val || val.length !== 10) {
          Swal.showValidationMessage('Please enter a valid 10-digit mobile number');
          return false;
        }
        return val;
      },
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        this.fetchAndApplyDraft(result.value);
      }
    });
  }

  fetchAndApplyDraft(mobileNo: string): void {
    this.isLoadingDraft = true;
    this.registerApiService
      .getNonMnfgDraftDetail(mobileNo)
      .pipe(
        finalize(() => {
          this.isLoadingDraft = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (res: any) => {
          const data = this.extractNonMnfgDraftData(res);
          if (!data) {
            const msg =
              typeof res?.message === 'string'
                ? res.message
                : 'No saved draft found for this mobile number.';
            Toast.fire({ icon: 'info', title: msg });
            return;
          }
          this.applyNonMnfgDraft(data);
          const successMsg =
            typeof res?.message === 'string'
              ? res.message
              : 'Draft loaded successfully. Continue your registration.';
          Toast.fire({ icon: 'success', title: successMsg });
        },
        error: (err: any) => {
          Toast.fire({
            icon: err?.status === 404 ? 'info' : 'error',
            title:
              err?.error?.message ||
              'Unable to load draft. Please verify the mobile number and try again.',
          });
        },
      });
  }

  private extractNonMnfgDraftData(res: any): any {
    if (!res) return null;
    let merged: any = {};
    let msgObj =
      res.message && typeof res.message === 'object' && !Array.isArray(res.message)
        ? res.message
        : null;
    let currentStep = res.currentStep ?? msgObj?.currentStep ?? 1;

    if (msgObj) {
      const formData = msgObj.data ?? msgObj.formData ?? msgObj.draft;
      if (formData && typeof formData === 'object' && !Array.isArray(formData)) {
        Object.assign(merged, formData);
      }
    }

    const candidates =
      Array.isArray(res.data) && res.data.length > 0
        ? res.data
        : [
            (!Array.isArray(res.data) && res.data && typeof res.data === 'object'
              ? res.data
              : null) ??
              res.result ??
              res,
          ];

    candidates.forEach((candidate: any) => {
      if (!candidate || typeof candidate !== 'object') return;

      // if candidate itself is a step payload
      const selfPayload = candidate.formData ?? candidate.data;
      if (selfPayload) {
        try {
          const parsed = typeof selfPayload === 'string' ? JSON.parse(selfPayload) : selfPayload;
          if (typeof parsed === 'object' && !Array.isArray(parsed)) {
            Object.assign(merged, parsed);
          }
        } catch (e) {}
      } else {
        // Just merge candidate directly if it doesn't have nested structures
        const skipDirect = new Set([
          'steps',
          'stepData',
          'draftData',
          'savedSteps',
          'registrationDraftSteps',
          'formData',
          'status',
          'message',
          'result',
          'data',
        ]);
        Object.keys(candidate).forEach((k) => {
          if (!skipDirect.has(k) && typeof candidate[k] !== 'object' && candidate[k] != null) {
            merged[k] = candidate[k];
          }
        });
      }

      const stepCollections = [
        candidate.steps,
        candidate.stepData,
        candidate.draftData,
        candidate.savedSteps,
        candidate.registrationDraftSteps,
        Array.isArray(candidate.formData) ? candidate.formData : null,
      ].filter(Array.isArray);

      stepCollections.forEach((steps: any[]) => {
        steps.forEach((item: any) => {
          const payload = item?.formData ?? item?.data ?? item;
          if (payload) {
            try {
              const parsed = typeof payload === 'string' ? JSON.parse(payload) : payload;
              if (typeof parsed === 'object' && !Array.isArray(parsed)) {
                Object.assign(merged, parsed);
              }
            } catch (e) {}
          }
        });
      });

      Object.keys(candidate).forEach((key) => {
        if (/^step[_-]?\d+$/i.test(key) && candidate[key]) {
          const stepVal = candidate[key];
          if (typeof stepVal === 'object') {
            Object.assign(merged, stepVal);
          } else if (typeof stepVal === 'string') {
            try {
              Object.assign(merged, JSON.parse(stepVal));
            } catch (e) {}
          }
        }
      });

      if (
        candidate.formData &&
        !Array.isArray(candidate.formData) &&
        typeof candidate.formData === 'object'
      ) {
        Object.assign(merged, candidate.formData);
      }
    });

    const hasContent =
      merged.mobileNo ||
      merged.powerStationsId ||
      merged.firmName ||
      merged.email ||
      merged.doorNo ||
      (Array.isArray(merged.nonManufactureCategoryDetails) &&
        merged.nonManufactureCategoryDetails.length) ||
      (Array.isArray(merged.ashCategoryDetails) && merged.ashCategoryDetails.length);

    if (!hasContent) return null;
    merged._currentStep = merged.currentStep ?? currentStep;
    return merged;
  }

  private applyNonMnfgDraft(data: any): void {
    const opts = { emitEvent: false };

    // Step 1
    if (data.mobileNo) {
      this.registerForm.patchValue({ mobileNumber: data.mobileNo }, opts);
      this.mobileOtpVerified = true;
      this.otpVerifiedMobile = data.mobileNo;
      this.mobileCheckStatus = 'valid';
      this.registerForm.get('mobileNumber')?.disable(opts);
    }

    if (data.powerStationsId) {
      this.registerForm.patchValue({ station: data.powerStationsId }, opts);
      this.loadAshCategories();
    }

    // Step 2 & others
    const patch: any = {};
    if (data.firmName) patch['firmName'] = data.firmName;
    if (data.email || data.emailAddress) patch['emailAddress'] = data.email || data.emailAddress;
    if (data.idProof) patch['idProof'] = data.idProof;

    // Address
    if (data.doorNo) patch['doorNo'] = data.doorNo;
    if (data.sfNo || data.surveyFieldNo) patch['surveyFieldNo'] = data.sfNo || data.surveyFieldNo;
    if (data.street || data.streetLocation)
      patch['streetLocation'] = data.street || data.streetLocation;
    if (data.stateId) patch['state'] = data.stateId;
    if (data.districtId) patch['district'] = data.districtId;
    if (data.talukId) patch['taluk'] = data.talukId;
    if (data.villageId) patch['village'] = data.villageId;
    if (data.pincode) patch['pincode'] = data.pincode;

    // Company Address
    if (data.isCompanyAddressSameAsPlant !== undefined)
      patch['sameAsPlantAddress'] = data.isCompanyAddressSameAsPlant;
    else if (data.isCompanySameAsPlant !== undefined)
      patch['sameAsPlantAddress'] = data.isCompanySameAsPlant;
    if (data.companyStateId) patch['companyState'] = data.companyStateId;
    if (data.companyDistrictId) patch['companyDistrict'] = data.companyDistrictId;
    if (data.companyTalukId) patch['companyTaluk'] = data.companyTalukId;
    if (data.companyVillageId) patch['companyVillage'] = data.companyVillageId;
    if (data.companyDoorNo) patch['companyDoorNo'] = data.companyDoorNo;
    if (data.companySfNo) patch['companySurveyFieldNo'] = data.companySfNo;
    if (data.companyStreet) patch['companyStreetLocation'] = data.companyStreet;
    if (data.companyPincode) patch['companyPincode'] = data.companyPincode;

    // Details
    if (data.capacity) patch['capacity'] = data.capacity;

    if (Object.keys(patch).length > 0) this.registerForm.patchValue(patch, opts);

    // Arrays
    if (
      Array.isArray(data.nonManufactureCategoryDetails) &&
      data.nonManufactureCategoryDetails.length > 0
    ) {
      this.registerForm.patchValue(
        { nonMnfgCategory: data.nonManufactureCategoryDetails[0].categoryId },
        opts,
      );
    }
    if (Array.isArray(data.ashCategoryDetails)) {
      const arr = this.registerForm.get('ashCategoryDetails') as FormArray;
      if (arr) {
        arr.clear();
        data.ashCategoryDetails.forEach((cat: any) => {
          arr.push(
            this.fb.group({
              categoryId: cat.categoryId,
              minLoad: [
                cat.minQuantity ?? cat.minLoad ?? '',
                [Validators.required, Validators.min(1)],
              ],
              maxLoad: [
                cat.maxQuantity ?? cat.maxLoad ?? '',
                [Validators.required, Validators.min(1)],
              ],
            }),
          );
        });
      }
    }

    // Docs
    const docs = data.documents || data.documentDetails || data.document;
    if (Array.isArray(docs)) {
      docs.forEach((doc: any) => {
        const key = Object.keys(this.documentTypeIds).find(
          (k) => this.documentTypeIds[k] === doc.documentTypeId,
        );
        if (key && doc.documentUploadId) {
          this.uploadedFileIds[key] = doc.documentUploadId.toString();
          this.uploadedFiles[key] = new File([''], 'Draft Document');
        }
      });
    }

    if (data.stateId) this.loadDistricts(data.stateId);
    if (data.districtId) this.loadTaluks(data.districtId);
    if (data.talukId) this.loadVillages(data.talukId);

    if (data.companyStateId) this.loadCompanyDistricts(data.companyStateId);
    if (data.companyDistrictId) this.loadCompanyTaluks(data.companyDistrictId);
    if (data.companyTalukId) this.loadCompanyVillages(data.companyTalukId);

    // Resume step (subtract 1 because UI step is 0-indexed)
    let step = data._currentStep;
    if (typeof step === 'string') step = Number(step);
    if (typeof step === 'number' && !isNaN(step) && step > 0) {
      this.activeStep = Math.min(step - 1, this.totalSteps - 1);
    }
  }
}
